import { Component, OnInit } from '@angular/core';
import { Util } from '../util/Util';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

const http: string = "http://";
const https: string = "https://";

declare let PRODUCT: any;
declare let userInterface: any;
declare let materialadmin: any;

export let PRODUCT_TS: any = null;
export let URL_PRODUCT: string;
export let DEFAULT_SUBDOMAIN_TS: string;

@Component({
    selector: 'app-root',
    templateUrl: '../../views/mainComponent.html',
    styleUrls: ['../../styles/main-component.css']
})

export class MainComponent implements OnInit {

    constructor(private router: Router) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        )
            .subscribe((event: NavigationEnd) => {
                // You only receive NavigationStart events
                //   materialadmin.AppNavigation.initialize();
                setTimeout(() => {
                    for (let key in materialadmin) { materialadmin[key].initialize() }
                    // console.log('onready');
                }, 500);

                //   console.log('onchange');
            });
    }

    private defineProduct(product: string) {
        product = product.toLowerCase();
        PRODUCT_TS = PRODUCT.LUDYACCOUNT;
        if (!product) {

            // acá colocamos el nombre (index) del producto que queremos que sea el default
            PRODUCT_TS = PRODUCT.LUDYACCOUNT;

        } else {
            for (let key in PRODUCT) {
                let pro = {
                    name: PRODUCT[key].NAME.toLowerCase(),
                    short_name: PRODUCT[key].SHORT_NAME.toLowerCase()
                };
                if (product == pro.name || product == pro.short_name) {
                    PRODUCT_TS = PRODUCT[key];
                }
            }
        }
       
    }


    verifyUrlProduct() {
        let productName = PRODUCT_TS.NAME.toLowerCase();
        if (PRODUCT_TS && (productName !== 'ludyaccount' && productName !== 'account')) {
            return PRODUCT_TS.URL_LOGIN;
        } else {
            return '';
        }
    }

    isSubdomain(url: string): boolean {
        url = url || 'http://www.test-domain.com'; // just for the example
        var regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]{4,})(\.\w{2,3})+(\:\d+)?/);

        return !!url.match(regex); // make sure it returns boolean
    }



    ngOnInit() {
        this.defineProduct(Util.getParameterByName('product'));
        let returnTo = Util.getParameterByName('return_to');
        let company = Util.getParameterByName('company');
        let tempUrl: string = "";
        let protocol: string = "";

        if (returnTo && this.isSubdomain(returnTo) && returnTo.includes(".")) {
            if (returnTo.includes(http)) {
                protocol = http;
            } else if (returnTo.includes(https)) {
                protocol = https;
            }

            let array: string[] = returnTo.split(".");

            array.forEach((elem: string, index: number) => {

                if (index > 0) {
                    tempUrl = tempUrl.concat((index == 1) ? elem + '.' : '' + elem);
                }
            });
            tempUrl = protocol + tempUrl;
            console.log("url: ", tempUrl);
        } else if (returnTo) {
            tempUrl = returnTo;
        }

        URL_PRODUCT = (tempUrl != "") ? tempUrl : this.verifyUrlProduct();
        DEFAULT_SUBDOMAIN_TS = (company != "") ? company : "";

        let title = document.getElementById("title");

        let body = document.getElementById("body");


        title.innerHTML = PRODUCT_TS.SYSTEM_TITLE;


        let head = document.getElementById("head");



        if (userInterface.useStryles) {

            let userInterfaceStyles = document.createElement("link");
            userInterfaceStyles.rel = "stylesheet";
            userInterfaceStyles.href = "styles/userInterface.css";


            head.appendChild(userInterfaceStyles);

            userInterfaceStyles.onload = () => {
                body.removeAttribute("style");
            };

            userInterfaceStyles.onerror = () => {
                body.removeAttribute("style");
            };
        } else {
            body.removeAttribute("style");
        }

        if (userInterface.favicon) {
            let favicon = document.createElement("link");
            favicon.rel = "shortcut icon";
            favicon.href = userInterface.favicon;
            head.appendChild(favicon);
        }
    }
}